import React, { useState, useEffect, } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Stack, Button, Box, Grid, Card, CardContent, CardActions, Paper, CircularProgress, Popover, Typography, Divider, MenuItem } from '@mui/material';
import client from '../common/client';
import IDEHeader from './IDEHeader';
import ProgramCode from './ProgramCode';
import CommonProgramCode from './CommonProgramCode';
import ProgramBlock from './ProgramBlock';
import ProjectExplore from './ProjectExplore';
import RightTool from './RightTool';
import IDENewScreen from './IDENewScreen';
import IDEScreenSetting from './IDEScreenSetting';
import IDELanguage from './IDELanguage';
import IDESketchAndFigma from './IDESketchAndFigma';

import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { orange, lime, purple } from '@mui/material/colors';
import { getLoginToken, getSelectedProject } from '../common/common';

const theme = createTheme({
    palette: {
        mode: 'dark',
    },
});

const IDE = props => {
    const navigate = useNavigate()
    const location = useLocation()
    const {path} = useParams()
    const [project_id, setProject_id] = useState('');
    const [screen_id, setScreen_id] = useState('');
    const [block_id, setBlock_id] = useState('');
    const [showScreen, setShowScreen] = useState(true);
    const [showProgramCode, setShowProgramCode] = useState(true);
    const [showProgramBlock, setShowProgramBlock] = useState(true);
    const [showScreenSetting, setShowScreenSetting] = useState(false);
    const [showCloud, setShowCloud] = useState(false);
    const [showLanguage, setShowLanguage] = useState(false);
    const [showCommonProgramCode, setCommonShowProgramCode] = useState(false);
    const [ProjectExploreRefreshIndex, setProjectExploreRefreshIndex] = useState(0);
    
    useEffect(() => {
        if(!getLoginToken()) {
            navigate('/#/login')
            return
        }
        
        const search = location.search;
        const query = new URLSearchParams(search)
        setScreen_id(query.get('screen_id'))
        setBlock_id(query.get('block_id'))
        if(query.get('language')) {
            setShowLanguage(true)
            setShowScreen(false)   
        }

        if(query.get('block_id')) {
            setShowProgramBlock(true)
            setCommonShowProgramCode(false)
            setShowScreenSetting(false)
            setShowCloud(false)
        }

        let project_id = query.get('project_id')
        if(project_id)
            sessionStorage.setItem('devil_project', project_id)

        setProject_id(getSelectedProject())
        
    }, [location])

    const handleRightToolClick = (name) => {
        if(name == 'block') {
            setShowProgramBlock(!showProgramBlock)
            setCommonShowProgramCode(false)
            setShowScreenSetting(false)
            setShowLanguage(false)
            setShowCloud(false)
        } else if(name == 'setting') {
            setShowProgramBlock(false)
            setCommonShowProgramCode(false)
            setShowScreenSetting(!showScreenSetting)
            setShowLanguage(false)
            setShowCloud(false)
        } else if(name == 'common') {
            setShowProgramBlock(false)
            setCommonShowProgramCode(true)
            setShowScreenSetting(false)
            setShowLanguage(false)
            setShowCloud(false)
        } else if(name == 'language') {
            setShowProgramBlock(false)
            setCommonShowProgramCode(false)
            setShowScreenSetting(false)
            setShowProgramCode(showLanguage)
            setShowLanguage(!showLanguage)
            setShowCloud(false)
        } else if(name == 'cloud') {
            setShowProgramBlock(false)
            setCommonShowProgramCode(false)
            setShowScreenSetting(false)
            setShowLanguage(false)
            setShowCloud(!showCloud)
        }
    }

    const onNewScreen = (screen_id) => {
        setProjectExploreRefreshIndex(ProjectExploreRefreshIndex + 1)
    }

    const onChangeProject = (project_id) => {
        setProjectExploreRefreshIndex(ProjectExploreRefreshIndex + 1)
        navigate('/ide/project?project_id=' + project_id)
    }

    const handleLanguageOptionChanged = (option, value) => {
        if(option == 'block') {
            setShowProgramBlock(value)
        }
    }

    return (
        // <ThemeProvider >
        //     <CssBaseline/>
        <Box sx={{ width:'100vw', height:'100vh', maxHeight:'100vh', overflow: 'hidden'}}>
            <Box>
                <IDEHeader onChangeProject={onChangeProject} />
            </Box>

            <Stack direction={{ xs: "column", md: "row" }} >
                <Box sx={{
                    width: { xs: '100%', md: '220px' },
                    height: { xs: '50px', md: 'calc(100vh - 50px)' }
                }}>
                    <ProjectExplore refreshIndex={ProjectExploreRefreshIndex}/>
                </Box>
                <Divider orientation="vertical" flexItem />
                
                <Stack direction="row" sx={{
                    width: 'calc(100vw - 270px)',
                    height: {
                        xs: 'calc(100vh - 150px)',
                        md: 'calc(100vh - 50px)'
                    }
                }}>
                    
                    {path == 'new' && <IDENewScreen onChange={onNewScreen}/>}
                    {screen_id && showScreen && showProgramCode && <ProgramCode screen_id={screen_id}/>}
                    {project_id && showCommonProgramCode && <CommonProgramCode project_id={project_id}/>}
                    {(showProgramBlock || showCloud ) && <Divider orientation="vertical" flexItem />}
                    {block_id && showProgramBlock && <ProgramBlock block_id={block_id} onClose={()=>{setShowProgramBlock(false)}} />}

                    {screen_id && showScreenSetting && <IDEScreenSetting screen_id={screen_id}/>}
                    {showLanguage && <IDELanguage project_id={project_id} screen_id={screen_id} block_id={block_id}  onChangeOption={handleLanguageOptionChanged}/>}
                    {showCloud && <IDESketchAndFigma/>}
                </Stack>

                <Divider orientation="vertical" flexItem />
                <Box sx={{
                    width: { xs: '100%', md: '80px' },
                    height: {
                        xs: '50px',
                        md: 'calc(100vh - 50px)'
                    }
                }}>
                    <RightTool clickRightTool={handleRightToolClick}/>
                </Box>
            </Stack>
        </Box>
        // </ThemeProvider>
    );
};

export default IDE;
